<input [disabled]="_disabled" [style]="_style" matInput type="number" [min]="_min" [max]="_max" [step]="_step"
    [value]="_value" (change)="onChange($event)" (keyup)="onKeyUp($event)" class="v-control"
    (blur)="onBlur($event)" (focus)="onFocus($event)"  autocomplete="off" #input
    />
